

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";


import InvoiceEstimateAnalyticsComp from "../../components/analytics/costandutilization/InvoiceEstimateAnalyticsComp";
import { toggleFullScreen } from "../../components/layout/functions/layout";
import Header from "../../components/layout/Header";
import Sidebar from "../../components/layout/Sidebar";

const InvoiceEstimateAnalytics = ({ nav }) => {
  const navigate = useNavigate();
  const userLogin = useSelector((state) => state.userSignIn);
  const { error, userInfo } = userLogin;


  useEffect(() => {
    if (!userInfo) {
      navigate("/sign-in");
    }
    window.scrollTo(0, 0);
    toggleFullScreen((nav = { nav }));
  }, [userInfo, navigate]);


  return (
    <>
      <div className={nav.isSidebar}>
        <Header nav={nav} />
        <Sidebar nav={nav} />
        <main className="page-content">
          <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
            <div className="breadcrumb-title pe-3">Dashboard</div>
            <div className="ps-3">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb mb-0 p-0">
                  <li className="breadcrumb-item">
                    <Link to="/">
                      <i className="bx bx-home-alt" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Sales Analytics
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <hr />
          
            <InvoiceEstimateAnalyticsComp nav={nav} />
          {/* <div className="row"> */}
            {/* main */}
          {/* </div> */}
        </main>

        <div className="overlay nav-toggle-icon" />
        <a href="#" className="back-to-top">
          <i className="bx bxs-up-arrow-alt" />
        </a>
      </div>
    </>
  );
};

export default InvoiceEstimateAnalytics;
